import { useNavigate } from 'react-router-dom'
import {
  Box,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import { GoogleLoginButton } from '@/components/GoogleLoginButton'

export const LoginPage = () => {
  const navigate = useNavigate()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        p: { xs: 2, sm: 3 },
      }}
    >
      <Card sx={{ maxWidth: 420, width: '100%', mx: { xs: 1, sm: 0 } }}>
        <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
          {/* Google ログイン */}
          <GoogleLoginButton
            variant="outlined"
            size={isMobile ? 'medium' : 'large'}
            onSuccess={() => navigate('/')}
            sx={{
              mb: 1.5,
              borderColor: 'divider',
              color: 'text.primary',
              '&:hover': { borderColor: 'text.secondary', bgcolor: 'grey.50' },
            }}
          />
        </CardContent>
      </Card>
    </Box>
  )
}
